export class UpdateProposalCommentDTO {
    ProposalId: number;
    Comment: string;
    constructor() {}
}
